import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  NumberInput,
  BulkDeleteButton,
  CreateButton,
  ExportButton,
  DateField,
  BooleanInput,
  BooleanField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
// import BookmarkIcon from '@material-ui/icons/Inbox';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';
import DateInput from '../../../../components/DateInput';

// import MarkingStatus from '../markingStatus';
import MarkingType from '../markingType';
import CodeType from '../codeType';
import EmissionType from '../emissionType';
import SerialNumType from '../serialNumType';
import resourceLocales from './locales';
import resourceConfig from './config';

import LinkToList from './LinkToList';
import BulkAggregateAction from './BulkAggregateAction';
import BulkDisaggregateAction from './BulkDisaggregateAction';
import BulkReaggregateAction from './BulkReaggregateAction';
import MrkInputButton from './MrkInputButton';
import MrkDocButton from './MrkDocButton';
import mrkStatusSystem from '../mrkStatusSystem';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import errorModel from '../errorModel';
import emissionType from '../emissionType';
import LoadButton from './LoadButton';
import UpdateKmButton from './UpdateKmButton';
import treeMrkLoadCustom from '../treeMrkLoadCustom';
import exporter from '../../../../utils/exporter';
import UpdateKmAllButton from './UpdateKmAllButton';
import BulkSoaSuiteSendAction from './BulkSoaSuiteSendAction';
import BulkUpdateAction from './BulkUpdateAction';
import mrkPackageType from '../mrkPackageType';
import PostPagination from '../../../../utils/pagination';

const ResourceIcon = BookmarkIcon;

const resourceToString = (x = {}) => `#${x.id}`;

const listStyles = {};

// const PackMButton = (props) => {
//     return (
//         <PackH.LinkToList
//             filter={{
//                 packhIds: props.record.id
//             }}
//         />
//     );
// }

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'cis'} />
    <DateInput
      source={'emissionDateFrom'}
      label={`resources.${resourceConfig.name}.filters.emissionDateFrom`}
    />
    <DateInput
      source={'emissionDateTo'}
      label={`resources.${resourceConfig.name}.filters.emissionDateTo`}
    />
    <TextInput source={'gtin'} />
    <TextInput source={'sgtin'} />
    <TextInput source={'tnvedGroup'} />
    <TextInput source={'ownerName'} />
    <TextInput source={'producerInn'} />
    <TextInput source={'producerName'} />
    <TextInput source={'ownerBin'} />
    <TextInput source={'producerBin'} />
    <TextInput source={'productName'} />
    <mrkPackageType.Field source={'сisPackageType'} />
    <mrkStatusSystem.Field source={'mrkSystemStatus'} />
    <DateInput source={'statusChangeDate'} showTime />
    <DateInput source={'producedDate'} showTime />
    <emissionType.Field source={'emissionType'} />
    <TextInput source={'lastDocId'} />
    <TextInput source={'name'} />
    <TextInput source={'brand'} />
    <TextInput source={'statusEx'} />
    <TextInput source={'tradeName'} />
    <TextInput source={'fullName'} />
    <TextInput source={'tnVedCode10'} />
    <TextInput source={'producerCountry'} />
    <TextInput source={'packageName'} />
    <TextInput source={'packMaterial'} />
    <TextInput source={'color'} />
    <TextInput source={'productSize'} />
    <TextInput source={'materialUpper'} />
    <TextInput source={'productTypeDesc'} />
    <TextInput source={'materialDown'} />
    <TextInput source={'contactPerson'} />
    <TextInput source={'ordernum'} />
  </Filter>
);

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    {/* <TreeMrkForBrokerButton {...props} /> */}
    {/* <BulkSoaSuiteSendAction {...props} />
    <MrkInputButton {...props} />
    <MrkDocButton {...props} /> */}
    <BulkUpdateAction {...props} />
    {/* <BulkAggregateAction {...props} /> */}
    {/* <BulkDisaggregateAction {...props} /> */}
    {/* <BulkReaggregateAction {...props} />/ */}
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <treeMrkLoadCustom.OpenButton />
    <UpdateKmAllButton />
    <LoadButton />
    <CreateButton basePath={basePath} />
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    actions={<ResourceListActions />}
    bulkActionButtons={<ResourceBulkActionButtons />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />
      <TextField source={'gtin'} />
      <TextField source={'sgtin'} />
      <emissionType.Field source={'emissionType'} />
      <TextField source={'contactPerson'} />
      <mrkStatusSystem.Field source={'mrkSystemStatus'} />
      <TextField source={'status'} />
      <TextField source={'ownerBin'} />
      <UpdateKmButton />
      <errorModel.LinkToRelatedList type={'TREEMRKKZ'} />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'cis'} />
      <DateInput
        source={'emissionDate'}
        label={`resources.${resourceConfig.name}.filters.emissionDate`}
      />
      <TextInput source={'gtin'} />
      <TextInput source={'sgtin'} />
      <TextInput source={'tnvedGroup'} />
      <TextInput source={'ownerName'} />
      <TextInput source={'producerInn'} />
      <TextInput source={'producerName'} />
      <TextInput source={'ownerBin'} />
      <TextInput source={'producerBin'} />
      <TextInput source={'productName'} />
      <mrkPackageType.Input source={'сisPackageType'} />
      <mrkStatusSystem.Input source={'mrkSystemStatus'} />
      <DateInput source={'statusChangeDate'} showTime />
      <DateInput source={'producedDate'} showTime />
      <emissionType.Field source={'emissionType'} />
      <TextInput source={'lastDocId'} />
      <TextInput source={'name'} />
      <TextInput source={'brand'} />
      <TextInput source={'statusEx'} />
      <TextInput source={'tradeName'} />
      <TextInput source={'fullName'} />
      <TextInput source={'tnVedCode10'} />
      <TextInput source={'producerCountry'} />
      <TextInput source={'packageName'} />
      <TextInput source={'packMaterial'} />
      <TextInput source={'color'} />
      <TextInput source={'productSize'} />
      <TextInput source={'materialUpper'} />
      <TextInput source={'productTypeDesc'} />
      <TextInput source={'materialDown'} />
      <TextInput source={'contactPerson'} />
      <TextInput source={'ordernum'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm>
      <TextField source={'id'} />
      <TextInput source={'cis'} />
      <DateInput
        source={'emissionDateFrom'}
        label={`resources.${resourceConfig.name}.filters.emissionDateFrom`}
      />
      <DateInput
        source={'emissionDateTo'}
        label={`resources.${resourceConfig.name}.filters.emissionDateTo`}
      />
      <TextInput source={'gtin'} />
      <TextInput source={'sgtin'} />
      <TextInput source={'tnvedGroup'} />
      <TextInput source={'ownerName'} />
      <TextInput source={'producerInn'} />
      <TextInput source={'producerName'} />
      <TextInput source={'ownerBin'} />
      <TextInput source={'producerBin'} />
      <TextInput source={'productName'} />
      <mrkPackageType.Input source={'сisPackageType'} />
      <mrkStatusSystem.Input source={'mrkSystemStatus'} />
      <DateInput source={'statusChangeDate'} showTime />
      <DateInput source={'producedDate'} showTime />
      <emissionType.Field source={'emissionType'} />
      <TextInput source={'lastDocId'} />
      <TextInput source={'name'} />
      <TextInput source={'brand'} />
      <TextInput source={'statusEx'} />
      <TextInput source={'tradeName'} />
      <TextInput source={'fullName'} />
      <TextInput source={'tnVedCode10'} />
      <TextInput source={'producerCountry'} />
      <TextInput source={'packageName'} />
      <TextInput source={'packMaterial'} />
      <TextInput source={'color'} />
      <TextInput source={'productSize'} />
      <TextInput source={'materialUpper'} />
      <TextInput source={'productTypeDesc'} />
      <TextInput source={'materialDown'} />
      <TextInput source={'contactPerson'} />
      <TextInput source={'ordernum'} />
    </SimpleForm>
  </Edit>
);

const ResourceStringField = ({ record }) => <span>{resourceToString(record)}</span>;

// const ResourceStringChipField = ({ record }) => (
//     <span>{resourceToString(record)}</span>
// )

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <ResourceStringField />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={resourceToString} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={resourceToString} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      emissionDate: {
        type: 'dateTime',
      },
      emissionDateFrom: {
        type: 'dateTime',
      },
      emissionDateTo: {
        type: 'dateTime',
      },
      producedDate: {
        type: 'dateTime',
      },
      dateInvoice: {
        type: 'dateTime',
      },
      invoiceAtkDate: {
        type: 'dateTime',
      },
      dateGtd: {
        type: 'dateTime',
      },
      statusChangeDate: {
        type: 'dateTime',
      },
      timestampDate: {
        type: 'dateTime',
      },
      dateInvoiceByDate: {
        type: 'date',
      },
      invoiceAtkDateByDate: {
        type: 'date',
      },
    },
  },
};
